import { render, staticRenderFns } from "./MakeOrder.vue?vue&type=template&id=18b1f7a0"
import script from "./MakeOrder.vue?vue&type=script&lang=js"
export * from "./MakeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports